import type React from 'react';

import { usePromoteCtaDisplayed } from '../../hooks/promoteCta';

import { SideSignedNonPromotableContainer } from './SideSignedNonPromotable';
import { SideSignedPromotableContainer } from './SideSignedPromotable';

export const SideSignedContainer: React.FC = () => {
	const ctaDisplayed = usePromoteCtaDisplayed();

	return ctaDisplayed ? <SideSignedPromotableContainer /> : <SideSignedNonPromotableContainer />;
};
